import { render, staticRenderFns } from "./MediaChooserLayer.vue?vue&type=template&id=6d6b66da&"
import script from "./MediaChooserLayer.vue?vue&type=script&lang=ts&"
export * from "./MediaChooserLayer.vue?vue&type=script&lang=ts&"
import style0 from "./MediaChooserLayer.vue?vue&type=style&index=0&id=6d6b66da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports